import { Texture } from './Texture';
import { Context } from '../context/Context';

export class BufferTexture extends Texture {
  constructor(private imageData: { data: Uint8Array; width: number; height: number }) {
    super();
    this.glTexture = null;
    this.translucent = false;
  }

  public initialize(ctx: Context, premultiplyAlpha: boolean = true): BufferTexture {
    this.uploadImageData(
      ctx,
      this.imageData.data,
      this.imageData.width,
      this.imageData.height,
      false,
      premultiplyAlpha,
    );
    this.translucent = this.detectTranslucency(this.imageData.data);
    return this;
  }

  private detectTranslucency(data: Uint8Array): boolean {
    for (let i = 3; i < data.length; i += 4) {
      if (data[i] < 255) return true;
    }
    return false;
  }
}
